import { Accordion, SimpleGrid } from '@mantine/core'
import { useTranslation } from 'react-i18next';

import { NUMBER_OF_QUESTIONS } from 'constants/app';
import { IconCaretDownFilled } from '@tabler/icons-react';
import classes from './index.module.css';

const AccordionItem = () => {
    const { t } = useTranslation();

    const questions = Array.from({ length: NUMBER_OF_QUESTIONS }).map((_, index) => (
        <Accordion.Item key={t(`faq.questions.${index}.question`)} value={t(`faq.questions.${index}.question`)} className={classes.question}>
            <Accordion.Control>{t(`faq.questions.${index}.question`)}</Accordion.Control>
            <Accordion.Panel>{t(`faq.questions.${index}.answer`)}</Accordion.Panel>
        </Accordion.Item>
    ));

    return (
        <Accordion variant='separated' chevron={<IconCaretDownFilled className={classes.icon} />} classNames={{ root: classes.root, item: classes.item, label: classes.label, control: classes.control, panel: classes.panel }}>
            <SimpleGrid cols={{ base: 1, md: 2 }} className={classes.questions}>
                {questions}
            </SimpleGrid>
        </Accordion>
    )
}

export default AccordionItem;